/** Typography glyphs as Unicode escapes (encoding-safe in source files). */
export const EM_DASH = '\u2014';
export const MIDDLE_DOT = '\u00B7';
export const ELLIPSIS = '\u2026';
